namespace $.$$ {

	export class $mol_svg_circle extends $.$mol_svg_circle {
		
		pos_x() {
			return this.pos()[ 0 ]
		}
		
		pos_y() {
			return this.pos()[ 1 ]
		}
		
	}
	
}
